<template>
  <div>
    <div>
      <div
        class="user"
        v-for="(a, idx) in stats"
        :key="idx"
      >
        <div>{{a.rank}}</div>
        <div><i class="fas fa-trophy mr-3" v-if="a.rank===1"></i> {{getPlayer(a.playerId).username}}</div>
        <div>{{a.scored}} / {{game.qnum}}</div>

      </div>
    </div>

    <button
      class="btn btn-success mt-5"
      v-on:click="toHomescreen()"
    >
      <i class="fas fa-home mr-3"></i>To the home screen
    </button>

    <div>

    </div>
  </div>
</template>

<script>
import GameService from "@/services/GameService.js";
import PlayerService from "@/services/PlayerService.js";

export default {
  name: "EndingMatch",
  data() {
    return {
      game: {
        playerIDs: [],
      },
      player: {},
      winner: {},
      players:[],
      stats:[],
      answers:{},
    };
  },
  async created() {
    // get gameCode for getting game
    const gameCode = this.$route.params.gameCode;
    this.gameCode = gameCode;
    try {
      this.players = await PlayerService.getPlayers();

      GameService.getGame(gameCode)
        .then((game) => {
          this.game = game;
          this.stats = game.stats;
          this.stats.sort((a, b) => {
            return b.scored - a.scored;
          });
          var rank = 1;
          for (var i = 0; i < this.stats.length; i++) {
            if (i > 0 && this.stats[i].scored < this.stats[i - 1].scored) {
              rank++;
            }
            this.stats[i].rank = rank;
          }
          this.player = this.$store.state.player;
          const playerIDs = this.game.playerIDs;
          if (!this.game || !this.player) {
            this.$router.push({
              name: "start",
            });
            return false;
          }
          // if game not in ending state
          if (this.game.state !== 2) {
            this.$router.push("/start");
            return false;
          }

          // get winner
          //this.winner = this.game.winner;
          // delete player
          setTimeout(() => {
            //PlayerService.deletePlayer(this.player.id);
            this.$store.dispatch("setPlayer", null);
            try {
              //GameService.deleteGame(gameCode);
            } catch (err) {}
          }, 2000);


          return false;
        })
        .catch((err) => {
          this.$router.push({
            name: "start",
          });
          return false;
        });
    } catch (err) {
      this.$router.push({
        name: "start",
        params: {
          error: "Sorry, something went wrong.. (Error code: #EM)",
        },
      });
      return false;
    }
  },
  methods: {
    getPlayer(playerId){
      return this.players.filter(a=>a.id===playerId)[0];
    },
    toHomescreen() {
      // delete game when exists
/*      try {
        GameService.getGame(this.game.gameCode).then((game) => {
          GameService.deleteGame(game.gameCode);
        });
      } catch (err) {}*/

      // push to homescreen
      this.$router.push("/start");
    },
  },
};
</script>
<style scoped>
h5.winner {
  font-weight: bold;
  font-size: 12rem;
}
.user{
  background-color: #08628a;
  color:#ffffff;
  font-size:30px;
  padding:10px 20px 10px 40px;
  width:100%;
  margin:10px;
  border-radius:3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fa-trophy{
  color:gold;
}
</style>
